import { useMemo } from "react";

import {
  FilterItemOptionValue,
  HierarchyFilterItemOption,
  HierarchyFilterOptionsMap,
} from "components/Filters/types";
import InfiniteList from "components/InfiniteList";
import Box from "ds/components/Box";

import { makeHierarchyOptions } from "../../helpers";
import styles from "./styles.module.css";
import FilterSectionEmpty from "./FilterSectionEmpty";
import HierarchyFilterOption from "./HierarchyFilterOption";

type HierarchyFilterOptionsListProps = {
  options: HierarchyFilterItemOption[];
  handleSelectHierarchyValue: (
    optionsMap?: HierarchyFilterOptionsMap
  ) => (value: string, forceOverride?: boolean) => void;
  selectedValues: Set<FilterItemOptionValue>;
  searchInput: string;
  titleId: string;
  filterName: string;
};

const HierarchyFilterOptionsList = ({
  handleSelectHierarchyValue,
  options,
  selectedValues,
  searchInput,
  titleId,
  filterName,
}: HierarchyFilterOptionsListProps) => {
  const [optionsMap, firstLevelOptions] = useMemo(
    () => makeHierarchyOptions(options, searchInput),
    [options, searchInput]
  );

  const hasIndentation = useMemo(() => options.some((item) => !!item.parentId), [options]);

  return (
    <InfiniteList items={firstLevelOptions}>
      {(items, onScroll) => (
        <Box
          role="group"
          aria-labelledby={titleId}
          direction="column"
          className={styles.valuesList}
          onScroll={onScroll}
        >
          {items.map((item) => (
            <HierarchyFilterOption
              key={item.id}
              filterName={filterName}
              item={item}
              optionsMap={optionsMap}
              handleSelectValue={handleSelectHierarchyValue}
              selectedValues={selectedValues}
              hasIndentation={hasIndentation}
            />
          ))}

          {firstLevelOptions.length === 0 && <FilterSectionEmpty />}
        </Box>
      )}
    </InfiniteList>
  );
};

export default HierarchyFilterOptionsList;
